import { useAuth } from "../context/AuthContext";
import type { AgeBand, ProfileRole } from "../types/profiles";

function normalize(role: any): ProfileRole | undefined {
  if (role === "enfant" || role === "child") return "enfant";
  if (role === "eleve" || role === "student") return "eleve";
  if (role === "enseignant" || role === "teacher") return "enseignant";
  if (role === "parent") return "parent";
  return role;
}

export function useIsKidProfile(): boolean {
  const { activeProfile } = useAuth();
  const role = normalize((activeProfile as any)?.role);
  const ageBand = (activeProfile as any)?.ageBand as AgeBand | undefined;
  return role === "enfant" || role === "eleve" || ageBand === "6-8" || ageBand === "9-11";
}

export function useIsTeacherProfile(): boolean {
  const { activeProfile } = useAuth();
  const role = normalize((activeProfile as any)?.role);
  return role === "enseignant";
}
